<template>
  <svg xmlns="http://www.w3.org/2000/svg" :width="size" :height="size" viewBox="0 0 48 48"><title>{{title }}</title>
    <g :fill="fill">
      <circle cx="8" cy="42" r="5"></circle>
      <circle cx="40" cy="42" r="5"></circle>
      <path d="M46,32H4.135l3.334-4H36c0.437,0,0.822-0.283,0.953-0.699l2.005-6.35C38.642,20.979,38.324,21,38,21 c-6.075,0-11-4.925-11-11c0-1.041,0.154-2.045,0.425-3H7.469l-4.7-5.64C2.415,0.936,1.785,0.878,1.36,1.232 C0.936,1.585,0.878,2.216,1.232,2.64L6,8.362v18.276L1.232,32.36c-0.248,0.298-0.302,0.713-0.137,1.064C1.259,33.775,1.613,34,2,34 h44c0.553,0,1-0.448,1-1S46.553,32,46,32z"></path>
      <path
        d="M38,1c-4.971,0-9,4.029-9,9s4.029,9,9,9s9-4.029,9-9S42.971,1,38,1z M42,11h-3v3 c0,0.552-0.448,1-1,1s-1-0.448-1-1v-3h-3c-0.552,0-1-0.448-1-1s0.448-1,1-1h3V6c0-0.552,0.448-1,1-1s1,0.448,1,1v3h3 c0.552,0,1,0.448,1,1S42.552,11,42,11z"></path>
    </g>
  </svg>
</template>

<script>
export default {
  name: "CartAdd",
  props: {
    title: {
      default: 'Ajouter au panier',
      type: String,
    },
    fill: {
      default: 'currentColor',
      type: String,
    },
    size: {
      type: Number,
      default: 18,
    },
  },
}
</script>
